//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "scoring-list",
  data() {
    return {
      wrapperHeight: 0,
      allLoaded: false,
      show: false,
      page: 0,
      scoreList: [],
      actionList: [],
      searchData: {'scoringScheme.scoringSchemeDetails.scoringPeople.status': 'ONGOING'},
      actionListChecked: [],
      classList: [{name: '全部', code: null}, {name: '评分中', code: 'ONGOING'}, {name: "已评分", code: 'FINISH'}],
      sourceId:null
    }
  },
  methods: {
    clear() {
      this.searchData['sourceProject'] = null;
      this.getSourcingList()
    },
    init: function () {
      // 父控件要加上高度，否则会出现上拉不动的情况
      this.wrapperHeight = document.documentElement.clientHeight - this.$refs.wrapper.getBoundingClientRect().top - 10;
    },
    sourcingClassChange(e) {
      if (e.code) {
        this.searchData['scoringScheme.scoringSchemeDetails.scoringPeople.status'] = e.code;
      } else {
        delete this.searchData['scoringScheme.scoringSchemeDetails.scoringPeople.status'];
      }
      this.getSourcingList();
    },
    loadTop() {
      this.$loadingShow();
      this.page = 0;
      this.$search('/api/sourceRating/scoring', {
        page: this.page,
        size: 15,
        sort: 'lastModifiedDate,DESC'
      }, this.searchData).then((list) => {
        this.scoreList = list;
        this.$loadingHide();
        this.$refs.loadmore.onTopLoaded();
      }).catch((error) => {
        this.$loadingHide();
        this.$refs.loadmore.onTopLoaded();
      });
    },
    loadBottom() {
      this.page++;
      this.$loadingShow();
      this.$search('/api/sourceRating/scoring', {
        page: this.page,
        size: 15,
        sort: 'lastModifiedDate,DESC'
      }, this.searchData).then((list) => {
        this.scoreList = this.scoreList.concat(list);
        this.$loadingHide();
        this.$refs.loadmore.onBottomLoaded();
      }).catch((error) => {
        this.$loadingHide();
      });
    },
    getSourcingList(){
      this.$loadingShow();
      this.$search('/api/sourceRating/scoring', {
        page: 0,
        size: 15,
        sort: 'lastModifiedDate,DESC'
      }, this.searchData).then((list) => {
        this.scoreList = list;
        this.$loadingHide();
      }).catch((error) => {
        this.$loadingHide();
      });
    },
    //跳转到详情页
    goSourceDetail(source) {
      this.actionList = [];
      if(source.scoringScheme && source.scoringScheme.scoringSchemeDetails){
        source.scoringScheme.scoringSchemeDetails.forEach((item) => {
          let str = item.dynamicForm.name;
          if(item.scoringPeople && item.scoringPeople[0]){
            if(item.scoringPeople[0].status === 'ONGOING'){
              str += '(评分中)';
            }else if(item.scoringPeople[0].status === 'FINISH'){
              str += '(已评分)';
            }else if(item.scoringPeople[0].status === 'NOT_STARTED'){
              str += '(未开始)';
            }
          }
          this.actionList.push({label:str,key:item.id})
        })
      }
      this.sourceId = source.sourcing.id;
      this.show = true;
    },
    goActionDetail(key,item){
      if(item){
        this.$router.push(`/source-scoring/sup-list/${this.sourceId}/${item.key}`);
      }
    }
  },
  mounted() {
    this.init();
    this.getSourcingList();
  }
}



// WEBPACK FOOTER //
// ./src/page/sources/source-score/scoring-list.vue